import { Pipe, PipeTransform } from '@angular/core';

import { Launcher } from '../models/entities/launcher.type';
import { AppConstants } from '../../app.constants';

@Pipe({
  name: 'isMawChromeLauncher'
})
export class IsMawChromeLauncherPipe implements PipeTransform {

  transform(launcher: Launcher): boolean {

    if (!launcher || !launcher.ExecutableName) {
      return false;
    }

    return launcher.ExecutableName.toLowerCase().includes(AppConstants.CHROME_LAUNCHER_TITLE_PREFIX);
  }

}
